import React from "react"
import Navbar from "../../../Common/Navbar"
import Footer from "../../../Common/Footer"
import Sidebar from "../../../Sidebar/Sidebar"
import DownloadCertificateComp from "./Component/DownloadCertificateComp"


const DownloadCertificate =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <DownloadCertificateComp />
        </div>
        <Footer />
        </>
    )
}

export default DownloadCertificate